const trackEvent = (data, gtm) => {
  // TODO: disable/enable based on ENV settings
  /* enable console log and disable dataLayer for local
  debugging so we dont contaminate the data in GA */
  // console.table({...data, gtm});

  if (typeof window !== 'undefined' && gtm) {
    window?.dataLayer?.push({ ...data });
  }
};

const gtmTemplates = {
  registrationStart: {
    event: 'registration',
    event_name: 'registration_start',
    event_category: 'registration',
    event_action: 'chose_registration_type',
  },
  tourData: {
    event: 'tour_registration',
    event_name: 'registration_progress',
    event_category: 'tour_registration',
    event_label: 'rondleiding aanvragen',
    type: 'old_method',
  },
};


const setDayCareString = (type) => {
  const string = type === 'Daycare' ?'KDV'
  : type === 'After school care' ? 'BSO'
  : 'POV';

  return string;
}

export { gtmTemplates, setDayCareString, trackEvent };

